export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lighttextDesc: true,
  topLine: 'WHAT ARE WE DOING',
  headline: 'Creating World Class Assitive Devices',
  description:
    'Joyforge Technologies is dedicated to pioneering world-class assistive technology devices tailored specifically for individuals with disabilities. Our approach is rooted in a deep understanding of the diverse needs and challenges faced by our users. By collaborating closely with experts in disability studies, healthcare professionals, and individuals with disabilities themselves, we ensure that our devices meet the highest standards of functionality, usability, and inclusivity.',
  buttonLabel: 'Know More',
  href: 'mailto:joyforgetechnolgies@gmail.com',
  imgStart: false,
  img: require('../../images/svg-1.svg').default,
  alt: 'design',
  dark: true,
  primary: true,
  darkText: false
};

export const homeObjTwo = {
  id: 'vision',
  lightBg: true,
  lightText: false,
  lighttextDesc: false,
  topLine: 'Our Vision',
  headline: 'Innovating independence through pioneering assistive technologies.',
  description: 'At Joyforge Technologies, we envision a world where individuals with disabilities have equal access to innovative assistive technologies that empower independence, foster inclusion, and enhance quality of life. We strive to lead in creating cutting-edge solutions that set new benchmarks in accessibility, usability, and user satisfaction. Our vision is to be recognized globally for pioneering advancements that break down barriers and enable individuals with disabilities to thrive with dignity and autonomy.',
  buttonLabel: 'Learn More',
  href: 'mailto:joyforgetechnolgies@gmail.com',
  imgStart: true,
  img: require('../../images/svg-2.svg').default,
  alt: 'industry',
  dark: false,
  primary: false,
  darkText: true
};

export const homeObjThree = {
  id: 'Mission',
  lightBg: false,
  lightText: true,
  lighttextDesc: true,
  topLine: 'Joyforge Technologies',
  headline: 'Innovation for inclusion, independence, enriched lives.',
  description: 'To empower individuals with disabilities by providing them with innovative tools that enhance independence, foster inclusion, and enrich quality of life. We believe in making a meaningful impact through technology, championing dignity, equality, and opportunity for all.',
  buttonLabel: 'Contact',
  href: 'mailto:joyforgetechnolgies@gmail.com',
  imgStart: false,
  img: require('../../images/svg-3.svg').default,
  alt: 'payment',
  primary: true,
  darkText: false
};
const text = `Partner with Joyforge Technologies to drive meaningful change through innovation in assistive technologies. Join us in creating solutions that empower independence, foster inclusion, and enrich lives globally. Together, we can make a profound impact, ensuring equal access and enhancing quality of life for individuals with disabilities.`
const newText = text.split('\n').map(str => <p>{str}</p>);

export const homeObjFour = {
  id: 'partner',
  lightBg: true,
  lightText: false,
  lighttextDesc: false,
  topLine: 'Partner with Us',
  headline: 'Join Our Network',
  description: newText,
  buttonLabel: 'Connect Now',
  href: 'mailto:joyforgetechnolgies@gmail.com',
  imgStart: true,
  img: require('../../images/svg-4.svg').default,
  alt: 'payment',
  dark: true,
  primary: true,
  darkText: true
};
